export default "__VITE_ASSET__DbagHO1h__"